import React from 'react';
import styled from 'styled-components';
import Tooltip from '../../Tooltip';
import Icon from '../../Icon';

const CellContactContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  a {
    text-decoration: none;
    color: inherit;
  }
  > * {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    background-color: rgba(173, 181, 189, 0.75);
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    justify-self: center;
    align-self: center;
    line-height: 10px;
  }

  > *:not(:last-child) {
    margin-right: 10px;
  }
`;

const CellContact = ({ value = {} }) => (
  <CellContactContainer>
    {value.phone && (
      <Tooltip placement="top" noCursor content={value.phone}>
        <a>
          <Icon className="phone" icon="phone" />
        </a>
      </Tooltip>
    )}
    {value.email && (
      <Tooltip placement="top" content={value.email}>
        <div style={{ marginBottom: '3px', marginLeft: '1px' }}>
          <a
            href={
              value.email.startsWith('http')
                ? value.email
                : `mailto:${value.email}`
            }
            target="_blank"
            rel="noreferrer"
          >
            @
          </a>
        </div>
      </Tooltip>
    )}
    {value.address && (
      <Tooltip placement="top" content={value.address}>
        <a
          target="_blank"
          href={`https://maps.google.com/?ll=${value.latitude},${value.longitude}`}
          rel="noreferrer"
        >
          <Icon icon="localisationContainer" />
        </a>
      </Tooltip>
    )}
    {value.site && (
      <Tooltip placement="top" content={value.site}>
        <a href={value.site} target="_blank" rel="noreferrer">
          <Icon icon="world" />
        </a>
      </Tooltip>
    )}
  </CellContactContainer>
);

export default CellContact;
